import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/channels',
    name: 'Channels',
    component: () => import(/* webpackChunkName: "channels" */ '../views/Channels.vue')
  },
  {
    path: '/c/:channel',
    name: 'ChannelDetail',
    components: {
      default: () => import(/* webpackChunkName: "channel-detail" */ '../views/ChannelDetail.vue'),
      header: () => import(/* webpackChunkName: "channel-detail-nav" */ '../components/ChannelDetailNav.vue'),
    }, 
    children: [
      {
        path: 'overview',
        name: 'ChannelDetailOverview',
        component: () => import(/* webpackChunkName: "channel-overview" */ '../views/ChannelOverview.vue')
      },
      {
        path: 'leaderboard',
        name: 'ChannelDetailLeaderboard',
        component: () => import(/* webpackChunkName: "channel-detail-leaderboard" */ '../views/ChannelLeaderboard.vue')
      },
      {
        path: 'facts',
        name: 'ChannelDetailFacts',
        component: () => import(/* webpackChunkName: "channel-detail-facts" */ '../views/ChannelFacts.vue')
      },
      {
        path: 'commands',
        name: 'ChannelDetailCommands',
        component: () => import(/* webpackChunkName: "channel-detail-commands" */ '../views/ChannelCommands.vue')
      },
      {
        path: 'quotes',
        name: 'ChannelDetailQuotes',
        component: () => import(/* webpackChunkName: "channel-detail-quotes" */ '../views/ChannelQuotes.vue')
      },
      {
        path: 'script',
        name: 'ChannelDetailScript',
        component: () => import(/* webpackChunkName: "channel-detail-script" */ '../views/ChannelScriptTemp.vue')
      }
    ]
  },
  {
    path: '/grammar',
    name: 'Grammar',
    component: () => import(/* webpackChunkName: "grammar" */ '../views/Grammar.vue')
  },
  {
    path: '/funtext',
    name: 'FUNtext',
    component: () => import(/* webpackChunkName: "funtext" */ '../views/FUNtext.vue')
  },
  {
    path: '/reference',
    name: 'Reference',
    component: () => import(/* webpackChunkName: "reference" */ '../views/Reference.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
